import type { TemplateGridSpan } from '@eshop/templates';

const ORDERED_BREAKPOINTS: Array<keyof TemplateGridSpan> = [
  'xxl',
  'xl',
  'lg',
  'md',
  'sm',
  'xs',
];

type BreakpointScreens = Partial<Record<keyof TemplateGridSpan, boolean>>;

const clamp = (value: number, min: number, max: number): number => {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
};

export const resolveBetweenRowsInsertIndex = (
  itemsLength: number,
  columns: number,
): number | null => {
  if (!Number.isFinite(columns) || columns <= 0 || itemsLength < columns * 2) {
    return null;
  }

  const ratio = itemsLength / columns;
  const maxRowBeforeBottom = Math.floor(ratio) - 1;
  const candidateRow = Math.min(Math.round(ratio / 2), 3);
  const targetRow = clamp(candidateRow, 1, maxRowBeforeBottom);

  return targetRow * columns;
};

export const resolveActiveCatalogueColumnCount = (
  visibleColumns: Partial<Record<keyof TemplateGridSpan, number>>,
  screens: BreakpointScreens,
  design?: string,
): number => {
  const activeBreakpoint =
    ORDERED_BREAKPOINTS.find((breakpoint) => screens[breakpoint]) ?? 'xs';
  const configuredColumns =
    visibleColumns[activeBreakpoint] ?? visibleColumns.xs ?? 1;

  // soft-commerce forces two cards per row on narrow screens via CSS, even when
  // the configured normal/large card size resolves xs to a single column.
  if (activeBreakpoint === 'xs' && design === 'soft-commerce') {
    return Math.max(configuredColumns, 2);
  }

  return configuredColumns;
};
